import { type Status, pollSchema } from "@/schemas";
import { filteredArray } from "@/schemas/utils";

import { QueryKeys } from "../../query-keys";
import { importEntities } from "../index";

/**
 * Import polls to the global cache from a list of statuses.
 *
 * @param statuses - array of Statuses
 */
function importPollsFromStatuses(statuses: Status[]) {
  const pollsToImport = statuses.map((status) => status.poll).filter(Boolean);

  const parsedResult = filteredArray(pollSchema).safeParse(pollsToImport);
  if (parsedResult.success) {
    importEntities(QueryKeys.polls.global, parsedResult.data);
  }
}

export { importPollsFromStatuses };
